import ZJApi from './api'
import utils from '../../utils'

const info = {
    service: 'UniformAuthService',
    controller: 'OrgUserInfo'
}
const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'GetItemById',
    'GetItemPagingList',
    'GetAllItems',
    'GetUsersByOrgId',
    'GetUsersPagingByOrgId',
    'GetContactUsersByOrgId',
    'FindUserCompany'
]

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
}

const OrgUserApi = ZJApi.defineNewApi('OrgUserApi', factory)

export default OrgUserApi